/* eslint-disable react-hooks/exhaustive-deps */
import React, { memo, useEffect, useState } from "react";
import { firestore } from "../firebase/config";
import GetReferenceDetails from "./GetReferenceDetails";
import ShowDonationsFromOthers from "./ShowDonationsFromOthers";
import { getDateInFormat } from "./utilities/Utils";
import { collectionGroup, query, where, onSnapshot } from "firebase/firestore";

function GetDonationsAndCommitmentsFromOthers(props) {
  const [donations, setDonations] = useState([]);
  const [commitments, setCommitments] = useState([]);
  useEffect(() => {
    let unsubscribe;
    if (props.donorId) {
      const fetchDonations = async () => {
        unsubscribe = await getDonations(props.donorId);
      };
      fetchDonations();
    }
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [props.donorId]);

  const getDonations = async (donorId) => {
    props.toggleIsGettingDonationsAndCommitmentsFromOthersFlag(true);
    const q = query(
      collectionGroup(firestore, "donations"),
      where("collectedBy", "==", donorId)
    );
    
    const unsubscribe = onSnapshot(q, (snapShot) => {
      let donationData = [];
      let commitmentData = [];

      if (!snapShot.empty) {
        snapShot.docs.forEach((data) => {
          let dData = data.data();
          let donorRefId = data.ref.parent.parent ? data.ref.parent.parent.id : "Unknown";
          
          let dataObj = {
            id: data.id,
            amount: dData.amount,
            donorName: (
              <GetReferenceDetails refId={donorRefId} needLink={true} />
            ),
            trust: dData.trust === "" ? "Not Applicable" : dData.trust,
            commissionAmount:
              dData.commissionAmount === "" ||
              dData.commissionAmount === undefined
                ? "0"
                : dData.commissionAmount,
            csrDonation: dData.csrDonation ? "Yes" : "No",
            date: dData.date && dData.date.toDate ? getDateInFormat(dData.date.toDate().toString()) : "N/A",
            onRecord: dData.onRecord ? "Yes" : "No",
            raisedThroughPlatform:
              dData.raisedThroughPlatform === "" ||
              dData.raisedThroughPlatform === undefined
                ? "Not Available"
                : dData.raisedThroughPlatform,
            mode: dData.mode,
            receivedThroughWebsite: dData.receivedThroughWebsite
              ? "Yes"
              : "No",
          };

          if (dData.type === "Donation") {
            donationData.push(dataObj);
          } else {
            commitmentData.push(dataObj);
          }
        });
      } else {
        console.log("No data found!");
      }
      
      setDonations(donationData);
      setCommitments(commitmentData);
      props.toggleIsGettingDonationsAndCommitmentsFromOthersFlag(false);
    }, (error) => {
      console.error("Error fetching donations from others:", error);
      props.toggleIsGettingDonationsAndCommitmentsFromOthersFlag(false);
    });

    return unsubscribe;
  };
  return (
    <>
      <div className="justify-content-center d-flex">
        <h3>Donations</h3>
      </div>
      {donations.length > 0 ? (
        <ShowDonationsFromOthers donations={donations} type="Donation" />
      ) : (
        <>
          <h4 className="justify-content-center d-flex">
            No Donations to show
          </h4>
        </>
      )}
      <div className="justify-content-center d-flex">
        <h3>Commitments</h3>
      </div>
      {commitments.length > 0 ? (
        <ShowDonationsFromOthers donations={commitments} type="Commitment" />
      ) : (
        <>
          <h4 className="justify-content-center d-flex">
            No Commitments to show
          </h4>
        </>
      )}
    </>
  );
}

export default memo(GetDonationsAndCommitmentsFromOthers);
